import {useEffect} from "react";
//import { BreadContext } from "../../../utils/context/breadcrum";
import GraphicPrincView from "../../graphics/principal";

function BeginView() {
 // const {setRuta} = BreadContext();
  useEffect(() => {
   // setRuta("Inicio");
  },[]);

  return <div className="">
           <GraphicPrincView></GraphicPrincView>
         </div>;

}

export default BeginView;
